import ajaxRequest from './ajax'
import qs from "qs"

// 获取审批表的标签
export const load_approval_dictionary_by_event = params => {
  return ajaxRequest.get("user/load_approval_dictionary_by_event?" + qs.stringify(params))
}
// 获取参会人的标签
export const load_event_dictionary_by_event = params => {
  return ajaxRequest.get("user/load_event_dictionary_by_event?" + qs.stringify(params))
}

//权限：系统用户 获取标签分类
export const get_tag_category = params => {
    return ajaxRequest.get("common/tag/get_tag_category?" + qs.stringify(params))
}

//关联活动
export const get_event_list_by_tag = params => {
  return ajaxRequest.get("common/tag/get_event_list_by_tag?" + qs.stringify(params))
}

//权限：系统用户 查询标签列表，按照条件
export const query_tags = params => {
    return ajaxRequest.get("common/tag/query_tags?" + qs.stringify(params))
}

//权限：系统管理员 创建或者修改标签
export const insert_or_update_tag = params => {
    return ajaxRequest.post("common/tag/insert_or_update_tag", params);
}

//权限：拖拽排序
export const update_tags_sort = params => {
  return ajaxRequest.post("common/tag/update_tags_sort", params);
}

//删除tag
export const delete_tag = params => {
    return ajaxRequest.post("common/tag/remove_tag?" + qs.stringify(params));
}



// WEBPACK FOOTER //
// ./src/api/tag.js